export enum EnViewMode {
    login = 'login',
    fullscreen = 'fullscreen',
    browse = 'browse',
    print = 'print'
}
